/**
 * NavigationPort — **page ไม่รู้จัก router** (Workspace-Structure §4)
 *
 * ทำไมสำคัญเป็นพิเศษตอนนี้: Open Decision #3 (TanStack Router vs React Router)
 * **ยังไม่เคาะ — เคาะวันที่ 4** · port ตัวนี้คือสิ่งที่ทำให้เลื่อนการตัดสินใจนั้น
 * ออกไปได้โดยไม่บล็อกงานวันนี้ และทำให้วันที่เคาะแล้วไม่ต้องแก้ page เลย
 */
export type AppRoute =
  | { name: 'home' }
  /** หน้า login สำหรับคนที่ไม่ได้เข้าจาก LINE (Day 3) */
  | { name: 'login' }
  /** หน้าขอความยินยอม PDPA — ต้องผ่านก่อนกรอกข้อมูลส่วนบุคคลใด ๆ (Build Plan §10) */
  | { name: 'pdpa-consent'; version: string }
  /** สมาชิกใหม่ที่ยินยอมแล้ว → พาไปกรอกโปรไฟล์ (หน้าจริงมาวันที่ 3) */
  | { name: 'profile-setup' }
  | { name: 'login-error'; reason: string };

/**
 * route ที่ **ผู้ใช้มาถึงด้วย URL ตรง ๆ** ไม่ใช่ปลายทางของ `navigation.go()`
 *
 * `/verify-email?token=…` คือลิงก์ในอีเมลยืนยัน — path นี้ตายตัวฝั่งเว็บ
 * (ฝั่ง backend ประกอบลิงก์จาก `WEB_BASE_URL` + path นี้ · `config/env.ts §readEmail`)
 * ⇒ **เปลี่ยน path นี้เมื่อไร ลิงก์ในเมลที่ส่งไปแล้วทั้งหมดตาย** — แก้ต้องแก้ 2 ฝั่งพร้อมกัน
 */
export const VERIFY_EMAIL_PATH = '/verify-email';
export const LOGIN_PATH = '/login';

export interface NavigationPort {
  go(route: AppRoute): void;
}
